module.exports = "/pages/business/hotelslabo/question_a.png";